/**
 * PortalStateSymbol.js
 *
 * Copyright (c) apploft. GmbH
 */

const unauthorized = Symbol('not logged in yet');
const authorizing = Symbol('waiting for authorization');
const authorized = Symbol('user is authorized');

export {unauthorized, authorizing, authorized};
